module.exports = __webpack_public_path__ + "img/ladder.a74cea10.svg";